//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "/api";

    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    batteriesGET(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<BatteryDtoODataDto> {
        let url_ = this.baseUrl + "/batteries?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteriesGET(_response);
        });
    }

    protected processBatteriesGET(response: AxiosResponse): Promise<BatteryDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryDtoODataDto.fromJS(resultData200);
            return Promise.resolve<BatteryDtoODataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteriesPOST(x_api_version: string | undefined, body: BatteryCreateRequest, cancelToken?: CancelToken): Promise<BatteryDto> {
        let url_ = this.baseUrl + "/batteries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteriesPOST(_response);
        });
    }

    protected processBatteriesPOST(response: AxiosResponse): Promise<BatteryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryDto.fromJS(resultData200);
            return Promise.resolve<BatteryDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteriesGET2(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<BatteryDto> {
        let url_ = this.baseUrl + "/batteries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteriesGET2(_response);
        });
    }

    protected processBatteriesGET2(response: AxiosResponse): Promise<BatteryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryDto.fromJS(resultData200);
            return Promise.resolve<BatteryDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteriesPUT(id: string, x_api_version: string | undefined, body: BatteryUpdateRequest, cancelToken?: CancelToken): Promise<BatteryDto> {
        let url_ = this.baseUrl + "/batteries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteriesPUT(_response);
        });
    }

    protected processBatteriesPUT(response: AxiosResponse): Promise<BatteryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryDto.fromJS(resultData200);
            return Promise.resolve<BatteryDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteriesDELETE(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<BatteryDto> {
        let url_ = this.baseUrl + "/batteries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteriesDELETE(_response);
        });
    }

    protected processBatteriesDELETE(response: AxiosResponse): Promise<BatteryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryDto.fromJS(resultData200);
            return Promise.resolve<BatteryDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    firmwaresGET(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<BatteryFirmwareDtoODataDto> {
        let url_ = this.baseUrl + "/batteries/firmwares?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFirmwaresGET(_response);
        });
    }

    protected processFirmwaresGET(response: AxiosResponse): Promise<BatteryFirmwareDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryFirmwareDtoODataDto.fromJS(resultData200);
            return Promise.resolve<BatteryFirmwareDtoODataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryFirmwareDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param version (optional) 
     * @param file (optional) 
     * @param description (optional) 
     * @param released (optional) 
     * @return OK
     */
    firmwaresPOST(x_api_version: string | undefined, version: string | undefined, file: FileParameter | undefined, description: string | undefined, released: boolean | undefined, cancelToken?: CancelToken): Promise<BatteryFirmwareDto> {
        let url_ = this.baseUrl + "/batteries/firmwares";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (version === null || version === undefined)
            throw new Error("The parameter 'version' cannot be null.");
        else
            content_.append("Version", version.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (released === null || released === undefined)
            throw new Error("The parameter 'released' cannot be null.");
        else
            content_.append("Released", released.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFirmwaresPOST(_response);
        });
    }

    protected processFirmwaresPOST(response: AxiosResponse): Promise<BatteryFirmwareDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryFirmwareDto.fromJS(resultData200);
            return Promise.resolve<BatteryFirmwareDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryFirmwareDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    firmwaresGET2(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<BatteryFirmwareDto> {
        let url_ = this.baseUrl + "/batteries/firmwares/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFirmwaresGET2(_response);
        });
    }

    protected processFirmwaresGET2(response: AxiosResponse): Promise<BatteryFirmwareDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryFirmwareDto.fromJS(resultData200);
            return Promise.resolve<BatteryFirmwareDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryFirmwareDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    firmwaresPUT(id: string, x_api_version: string | undefined, body: BatteryFirmwareUpdateRequest, cancelToken?: CancelToken): Promise<BatteryFirmwareDto> {
        let url_ = this.baseUrl + "/batteries/firmwares/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFirmwaresPUT(_response);
        });
    }

    protected processFirmwaresPUT(response: AxiosResponse): Promise<BatteryFirmwareDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryFirmwareDto.fromJS(resultData200);
            return Promise.resolve<BatteryFirmwareDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryFirmwareDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    firmwaresDELETE(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<BatteryFirmwareDto> {
        let url_ = this.baseUrl + "/batteries/firmwares/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFirmwaresDELETE(_response);
        });
    }

    protected processFirmwaresDELETE(response: AxiosResponse): Promise<BatteryFirmwareDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryFirmwareDto.fromJS(resultData200);
            return Promise.resolve<BatteryFirmwareDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryFirmwareDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    download(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/batteries/firmwares/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    batteryStationsGET(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<BatteryStationDtoODataDto> {
        let url_ = this.baseUrl + "/battery-stations?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteryStationsGET(_response);
        });
    }

    protected processBatteryStationsGET(response: AxiosResponse): Promise<BatteryStationDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryStationDtoODataDto.fromJS(resultData200);
            return Promise.resolve<BatteryStationDtoODataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryStationDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteryStationsPOST(x_api_version: string | undefined, body: BatteryStationCreateRequest, cancelToken?: CancelToken): Promise<BatteryStationDto> {
        let url_ = this.baseUrl + "/battery-stations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteryStationsPOST(_response);
        });
    }

    protected processBatteryStationsPOST(response: AxiosResponse): Promise<BatteryStationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryStationDto.fromJS(resultData200);
            return Promise.resolve<BatteryStationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryStationDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteryStationsGET2(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<BatteryStationDto> {
        let url_ = this.baseUrl + "/battery-stations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteryStationsGET2(_response);
        });
    }

    protected processBatteryStationsGET2(response: AxiosResponse): Promise<BatteryStationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryStationDto.fromJS(resultData200);
            return Promise.resolve<BatteryStationDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryStationDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteryStationsPUT(id: string, x_api_version: string | undefined, body: BatteryStationUpdateRequest, cancelToken?: CancelToken): Promise<BatteryStationDto> {
        let url_ = this.baseUrl + "/battery-stations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteryStationsPUT(_response);
        });
    }

    protected processBatteryStationsPUT(response: AxiosResponse): Promise<BatteryStationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatteryStationDto.fromJS(resultData200);
            return Promise.resolve<BatteryStationDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatteryStationDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteryStationsDELETE(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/battery-stations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteryStationsDELETE(_response);
        });
    }

    protected processBatteryStationsDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    batteriesAll(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<BatterySubscriptionSummaryDto[]> {
        let url_ = this.baseUrl + "/subscriptions/batteries?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteriesAll(_response);
        });
    }

    protected processBatteriesAll(response: AxiosResponse): Promise<BatterySubscriptionSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatterySubscriptionSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BatterySubscriptionSummaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatterySubscriptionSummaryDto[]>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteriesPOST2(x_api_version: string | undefined, body: BatterySubscriptionCreateRequest, cancelToken?: CancelToken): Promise<BatterySubscriptionDto> {
        let url_ = this.baseUrl + "/subscriptions/batteries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteriesPOST2(_response);
        });
    }

    protected processBatteriesPOST2(response: AxiosResponse): Promise<BatterySubscriptionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatterySubscriptionDto.fromJS(resultData200);
            return Promise.resolve<BatterySubscriptionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatterySubscriptionDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteriesGET3(shopSubscriptionId: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<BatterySubscriptionSummaryDto> {
        let url_ = this.baseUrl + "/subscriptions/batteries/{shopSubscriptionId}";
        if (shopSubscriptionId === undefined || shopSubscriptionId === null)
            throw new Error("The parameter 'shopSubscriptionId' must be defined.");
        url_ = url_.replace("{shopSubscriptionId}", encodeURIComponent("" + shopSubscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteriesGET3(_response);
        });
    }

    protected processBatteriesGET3(response: AxiosResponse): Promise<BatterySubscriptionSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatterySubscriptionSummaryDto.fromJS(resultData200);
            return Promise.resolve<BatterySubscriptionSummaryDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatterySubscriptionSummaryDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteriesPUT2(shopSubscriptionId: string, x_api_version: string | undefined, body: BatterySubscriptionUpdateRequest, cancelToken?: CancelToken): Promise<BatterySubscriptionDto> {
        let url_ = this.baseUrl + "/subscriptions/batteries/{shopSubscriptionId}";
        if (shopSubscriptionId === undefined || shopSubscriptionId === null)
            throw new Error("The parameter 'shopSubscriptionId' must be defined.");
        url_ = url_.replace("{shopSubscriptionId}", encodeURIComponent("" + shopSubscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteriesPUT2(_response);
        });
    }

    protected processBatteriesPUT2(response: AxiosResponse): Promise<BatterySubscriptionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BatterySubscriptionDto.fromJS(resultData200);
            return Promise.resolve<BatterySubscriptionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BatterySubscriptionDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    batteriesDELETE2(shopSubscriptionId: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/subscriptions/batteries/{shopSubscriptionId}";
        if (shopSubscriptionId === undefined || shopSubscriptionId === null)
            throw new Error("The parameter 'shopSubscriptionId' must be defined.");
        url_ = url_.replace("{shopSubscriptionId}", encodeURIComponent("" + shopSubscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatteriesDELETE2(_response);
        });
    }

    protected processBatteriesDELETE2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    groups(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<GroupInfoDtoODataDto> {
        let url_ = this.baseUrl + "/groups?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGroups(_response);
        });
    }

    protected processGroups(response: AxiosResponse): Promise<GroupInfoDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GroupInfoDtoODataDto.fromJS(resultData200);
            return Promise.resolve<GroupInfoDtoODataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupInfoDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    homeChargersGET(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<HomeChargerDtoODataDto> {
        let url_ = this.baseUrl + "/home-chargers?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHomeChargersGET(_response);
        });
    }

    protected processHomeChargersGET(response: AxiosResponse): Promise<HomeChargerDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HomeChargerDtoODataDto.fromJS(resultData200);
            return Promise.resolve<HomeChargerDtoODataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeChargerDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    homeChargersPOST(x_api_version: string | undefined, body: HomeChargerCreateRequest, cancelToken?: CancelToken): Promise<HomeChargerDto> {
        let url_ = this.baseUrl + "/home-chargers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHomeChargersPOST(_response);
        });
    }

    protected processHomeChargersPOST(response: AxiosResponse): Promise<HomeChargerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HomeChargerDto.fromJS(resultData200);
            return Promise.resolve<HomeChargerDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeChargerDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    homeChargersGET2(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<HomeChargerDto> {
        let url_ = this.baseUrl + "/home-chargers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHomeChargersGET2(_response);
        });
    }

    protected processHomeChargersGET2(response: AxiosResponse): Promise<HomeChargerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HomeChargerDto.fromJS(resultData200);
            return Promise.resolve<HomeChargerDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeChargerDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    homeChargersPUT(id: string, x_api_version: string | undefined, body: HomeChargerUpdateRequest, cancelToken?: CancelToken): Promise<HomeChargerDto> {
        let url_ = this.baseUrl + "/home-chargers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHomeChargersPUT(_response);
        });
    }

    protected processHomeChargersPUT(response: AxiosResponse): Promise<HomeChargerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HomeChargerDto.fromJS(resultData200);
            return Promise.resolve<HomeChargerDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeChargerDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    homeChargersDELETE(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<HomeChargerDto> {
        let url_ = this.baseUrl + "/home-chargers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHomeChargersDELETE(_response);
        });
    }

    protected processHomeChargersDELETE(response: AxiosResponse): Promise<HomeChargerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HomeChargerDto.fromJS(resultData200);
            return Promise.resolve<HomeChargerDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeChargerDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    homeChargersAll(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<HomeChargerSubscriptionSummaryDto[]> {
        let url_ = this.baseUrl + "/subscriptions/home-chargers?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHomeChargersAll(_response);
        });
    }

    protected processHomeChargersAll(response: AxiosResponse): Promise<HomeChargerSubscriptionSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HomeChargerSubscriptionSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HomeChargerSubscriptionSummaryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeChargerSubscriptionSummaryDto[]>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    homeChargersPOST2(x_api_version: string | undefined, body: HomeChargerSubscriptionCreateRequest, cancelToken?: CancelToken): Promise<HomeChargerSubscriptionDto> {
        let url_ = this.baseUrl + "/subscriptions/home-chargers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHomeChargersPOST2(_response);
        });
    }

    protected processHomeChargersPOST2(response: AxiosResponse): Promise<HomeChargerSubscriptionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HomeChargerSubscriptionDto.fromJS(resultData200);
            return Promise.resolve<HomeChargerSubscriptionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeChargerSubscriptionDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    homeChargersGET3(shopSubscriptionId: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<HomeChargerSubscriptionSummaryDto> {
        let url_ = this.baseUrl + "/subscriptions/home-chargers/{shopSubscriptionId}";
        if (shopSubscriptionId === undefined || shopSubscriptionId === null)
            throw new Error("The parameter 'shopSubscriptionId' must be defined.");
        url_ = url_.replace("{shopSubscriptionId}", encodeURIComponent("" + shopSubscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHomeChargersGET3(_response);
        });
    }

    protected processHomeChargersGET3(response: AxiosResponse): Promise<HomeChargerSubscriptionSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HomeChargerSubscriptionSummaryDto.fromJS(resultData200);
            return Promise.resolve<HomeChargerSubscriptionSummaryDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeChargerSubscriptionSummaryDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    homeChargersPUT2(shopSubscriptionId: string, x_api_version: string | undefined, body: HomeChargerSubscriptionUpdateRequest, cancelToken?: CancelToken): Promise<HomeChargerSubscriptionDto> {
        let url_ = this.baseUrl + "/subscriptions/home-chargers/{shopSubscriptionId}";
        if (shopSubscriptionId === undefined || shopSubscriptionId === null)
            throw new Error("The parameter 'shopSubscriptionId' must be defined.");
        url_ = url_.replace("{shopSubscriptionId}", encodeURIComponent("" + shopSubscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHomeChargersPUT2(_response);
        });
    }

    protected processHomeChargersPUT2(response: AxiosResponse): Promise<HomeChargerSubscriptionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HomeChargerSubscriptionDto.fromJS(resultData200);
            return Promise.resolve<HomeChargerSubscriptionDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HomeChargerSubscriptionDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    homeChargersDELETE2(shopSubscriptionId: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/subscriptions/home-chargers/{shopSubscriptionId}";
        if (shopSubscriptionId === undefined || shopSubscriptionId === null)
            throw new Error("The parameter 'shopSubscriptionId' must be defined.");
        url_ = url_.replace("{shopSubscriptionId}", encodeURIComponent("" + shopSubscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHomeChargersDELETE2(_response);
        });
    }

    protected processHomeChargersDELETE2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    logs(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<ApiLogDtoODataDto> {
        let url_ = this.baseUrl + "/logs?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogs(_response);
        });
    }

    protected processLogs(response: AxiosResponse): Promise<ApiLogDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiLogDtoODataDto.fromJS(resultData200);
            return Promise.resolve<ApiLogDtoODataDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiLogDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    login(x_api_version: string | undefined, cancelToken?: CancelToken): Promise<TokenDto> {
        let url_ = this.baseUrl + "/login";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<TokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenDto.fromJS(resultData200);
            return Promise.resolve<TokenDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    refreshToken(x_api_version: string | undefined, body: RefreshTokenRequest, cancelToken?: CancelToken): Promise<TokenDto> {
        let url_ = this.baseUrl + "/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<TokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenDto.fromJS(resultData200);
            return Promise.resolve<TokenDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    logout(x_api_version: string | undefined, cancelToken?: CancelToken): Promise<TokenDto> {
        let url_ = this.baseUrl + "/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<TokenDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenDto.fromJS(resultData200);
            return Promise.resolve<TokenDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    notificationsAll(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<NotificationDto[]> {
        let url_ = this.baseUrl + "/notifications?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationsAll(_response);
        });
    }

    protected processNotificationsAll(response: AxiosResponse): Promise<NotificationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NotificationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationDto[]>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    notifications(x_api_version: string | undefined, body: SendNotificationRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotifications(_response);
        });
    }

    protected processNotifications(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    roles(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<RoleDtoODataDto> {
        let url_ = this.baseUrl + "/roles?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoles(_response);
        });
    }

    protected processRoles(response: AxiosResponse): Promise<RoleDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDtoODataDto.fromJS(resultData200);
            return Promise.resolve<RoleDtoODataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    swapsGET(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<SwapDtoODataDto> {
        let url_ = this.baseUrl + "/swaps?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwapsGET(_response);
        });
    }

    protected processSwapsGET(response: AxiosResponse): Promise<SwapDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SwapDtoODataDto.fromJS(resultData200);
            return Promise.resolve<SwapDtoODataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwapDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    values(x_api_version: string | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/swaps/status/values";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValues(_response);
        });
    }

    protected processValues(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    swapsPUT(id: string, x_api_version: string | undefined, body: UpdateSwapRequest | undefined, cancelToken?: CancelToken): Promise<SwapDto> {
        let url_ = this.baseUrl + "/swaps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwapsPUT(_response);
        });
    }

    protected processSwapsPUT(response: AxiosResponse): Promise<SwapDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SwapDto.fromJS(resultData200);
            return Promise.resolve<SwapDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwapDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    appGET(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<UserDtoODataDto> {
        let url_ = this.baseUrl + "/users/app?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAppGET(_response);
        });
    }

    protected processAppGET(response: AxiosResponse): Promise<UserDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDtoODataDto.fromJS(resultData200);
            return Promise.resolve<UserDtoODataDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    appGET2(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<AppUserDetailsDto> {
        let url_ = this.baseUrl + "/users/app/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAppGET2(_response);
        });
    }

    protected processAppGET2(response: AxiosResponse): Promise<AppUserDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserDetailsDto.fromJS(resultData200);
            return Promise.resolve<AppUserDetailsDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserDetailsDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    appDELETE(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/users/app/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAppDELETE(_response);
        });
    }

    protected processAppDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    anonymize(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/users/app/{id}/anonymize";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnonymize(_response);
        });
    }

    protected processAnonymize(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    tester(id: string, x_api_version: string | undefined, body: SetTesterRequest, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/users/app/{id}/tester";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTester(_response);
        });
    }

    protected processTester(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    usersGET(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<BackofficeUserDtoODataDto> {
        let url_ = this.baseUrl + "/users?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersGET(_response);
        });
    }

    protected processUsersGET(response: AxiosResponse): Promise<BackofficeUserDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BackofficeUserDtoODataDto.fromJS(resultData200);
            return Promise.resolve<BackofficeUserDtoODataDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BackofficeUserDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    invite(x_api_version: string | undefined, body: InviteUserRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/users/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvite(_response);
        });
    }

    protected processInvite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    role(id: string, x_api_version: string | undefined, body: UserRoleUpdateRequest | undefined, cancelToken?: CancelToken): Promise<BackofficeUserDto> {
        let url_ = this.baseUrl + "/users/{id}/role";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRole(_response);
        });
    }

    protected processRole(response: AxiosResponse): Promise<BackofficeUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BackofficeUserDto.fromJS(resultData200);
            return Promise.resolve<BackofficeUserDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BackofficeUserDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    usersDELETE(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersDELETE(_response);
        });
    }

    protected processUsersDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    me(x_api_version: string | undefined, cancelToken?: CancelToken): Promise<BackofficeUserDto> {
        let url_ = this.baseUrl + "/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<BackofficeUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BackofficeUserDto.fromJS(resultData200);
            return Promise.resolve<BackofficeUserDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BackofficeUserDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    authorizedEndpoints(x_api_version: string | undefined, cancelToken?: CancelToken): Promise<AuthorizedPolicyDto[]> {
        let url_ = this.baseUrl + "/me/authorized-endpoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthorizedEndpoints(_response);
        });
    }

    protected processAuthorizedEndpoints(response: AxiosResponse): Promise<AuthorizedPolicyDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorizedPolicyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AuthorizedPolicyDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthorizedPolicyDto[]>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    vehiclesGET(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<VehicleDtoODataDto> {
        let url_ = this.baseUrl + "/vehicles?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehiclesGET(_response);
        });
    }

    protected processVehiclesGET(response: AxiosResponse): Promise<VehicleDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleDtoODataDto.fromJS(resultData200);
            return Promise.resolve<VehicleDtoODataDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    vehiclesPOST(x_api_version: string | undefined, body: VehicleCreateRequest, cancelToken?: CancelToken): Promise<VehicleDto> {
        let url_ = this.baseUrl + "/vehicles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehiclesPOST(_response);
        });
    }

    protected processVehiclesPOST(response: AxiosResponse): Promise<VehicleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleDto.fromJS(resultData200);
            return Promise.resolve<VehicleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    vehiclesGET2(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<VehicleDto> {
        let url_ = this.baseUrl + "/vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehiclesGET2(_response);
        });
    }

    protected processVehiclesGET2(response: AxiosResponse): Promise<VehicleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleDto.fromJS(resultData200);
            return Promise.resolve<VehicleDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    vehiclesPUT(id: string, x_api_version: string | undefined, body: VehicleUpdateRequest, cancelToken?: CancelToken): Promise<VehicleDto> {
        let url_ = this.baseUrl + "/vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehiclesPUT(_response);
        });
    }

    protected processVehiclesPUT(response: AxiosResponse): Promise<VehicleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleDto.fromJS(resultData200);
            return Promise.resolve<VehicleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return No Content
     */
    vehiclesDELETE(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehiclesDELETE(_response);
        });
    }

    protected processVehiclesDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    firmwaresGET3(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<VehicleFirmwareDtoODataDto> {
        let url_ = this.baseUrl + "/vehicles/firmwares?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFirmwaresGET3(_response);
        });
    }

    protected processFirmwaresGET3(response: AxiosResponse): Promise<VehicleFirmwareDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleFirmwareDtoODataDto.fromJS(resultData200);
            return Promise.resolve<VehicleFirmwareDtoODataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleFirmwareDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param vehicleModelId (optional) 
     * @param version (optional) 
     * @param file (optional) 
     * @param description (optional) 
     * @param released (optional) 
     * @return OK
     */
    firmwaresPOST2(x_api_version: string | undefined, vehicleModelId: string | undefined, version: string | undefined, file: FileParameter | undefined, description: string | undefined, released: boolean | undefined, cancelToken?: CancelToken): Promise<VehicleFirmwareDto> {
        let url_ = this.baseUrl + "/vehicles/firmwares";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (vehicleModelId === null || vehicleModelId === undefined)
            throw new Error("The parameter 'vehicleModelId' cannot be null.");
        else
            content_.append("VehicleModelId", vehicleModelId.toString());
        if (version === null || version === undefined)
            throw new Error("The parameter 'version' cannot be null.");
        else
            content_.append("Version", version.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (released === null || released === undefined)
            throw new Error("The parameter 'released' cannot be null.");
        else
            content_.append("Released", released.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFirmwaresPOST2(_response);
        });
    }

    protected processFirmwaresPOST2(response: AxiosResponse): Promise<VehicleFirmwareDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleFirmwareDto.fromJS(resultData200);
            return Promise.resolve<VehicleFirmwareDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleFirmwareDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    firmwaresGET4(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<VehicleFirmwareDto> {
        let url_ = this.baseUrl + "/vehicles/firmwares/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFirmwaresGET4(_response);
        });
    }

    protected processFirmwaresGET4(response: AxiosResponse): Promise<VehicleFirmwareDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleFirmwareDto.fromJS(resultData200);
            return Promise.resolve<VehicleFirmwareDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleFirmwareDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    firmwaresPUT2(id: string, x_api_version: string | undefined, body: VehicleFirmwareUpdateRequest, cancelToken?: CancelToken): Promise<VehicleFirmwareDto> {
        let url_ = this.baseUrl + "/vehicles/firmwares/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFirmwaresPUT2(_response);
        });
    }

    protected processFirmwaresPUT2(response: AxiosResponse): Promise<VehicleFirmwareDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleFirmwareDto.fromJS(resultData200);
            return Promise.resolve<VehicleFirmwareDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleFirmwareDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    firmwaresDELETE2(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<VehicleFirmwareDto> {
        let url_ = this.baseUrl + "/vehicles/firmwares/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFirmwaresDELETE2(_response);
        });
    }

    protected processFirmwaresDELETE2(response: AxiosResponse): Promise<VehicleFirmwareDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleFirmwareDto.fromJS(resultData200);
            return Promise.resolve<VehicleFirmwareDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleFirmwareDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    download2(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/vehicles/firmwares/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload2(_response);
        });
    }

    protected processDownload2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @param select (optional) 
     * @param filter (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param orderby (optional) 
     * @param count (optional) 
     * @return OK
     */
    vehicleModels(x_api_version: string | undefined, select: string | undefined, filter: string | undefined, top: string | undefined, skip: string | undefined, orderby: string | undefined, count: boolean | undefined, cancelToken?: CancelToken): Promise<VehicleModelDtoODataDto> {
        let url_ = this.baseUrl + "/vehicle-models?";
        if (select === null)
            throw new Error("The parameter 'select' cannot be null.");
        else if (select !== undefined)
            url_ += "$select=" + encodeURIComponent("" + select) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "$count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehicleModels(_response);
        });
    }

    protected processVehicleModels(response: AxiosResponse): Promise<VehicleModelDtoODataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleModelDtoODataDto.fromJS(resultData200);
            return Promise.resolve<VehicleModelDtoODataDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleModelDtoODataDto>(null as any);
    }

    /**
     * @param x_api_version (optional) 
     * @return OK
     */
    vehicleModels2(id: string, x_api_version: string | undefined, cancelToken?: CancelToken): Promise<VehicleModelDto> {
        let url_ = this.baseUrl + "/vehicle-models/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "x-api-version": x_api_version !== undefined && x_api_version !== null ? "" + x_api_version : "",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehicleModels2(_response);
        });
    }

    protected processVehicleModels2(response: AxiosResponse): Promise<VehicleModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleModelDto.fromJS(resultData200);
            return Promise.resolve<VehicleModelDto>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleModelDto>(null as any);
    }
}

export class ApiLogDto implements IApiLogDto {
    id!: string;
    userId?: string | undefined;
    userIdentifier?: string | undefined;
    httpMethod!: string | undefined;
    path!: string | undefined;
    queryString?: string | undefined;
    payload?: string | undefined;
    statusCode!: number;
    durationMs!: number;
    ipAddress?: string | undefined;
    userAgent?: string | undefined;
    groupId?: string | undefined;
    timestamp!: Date;

    constructor(data?: IApiLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userIdentifier = _data["userIdentifier"];
            this.httpMethod = _data["httpMethod"];
            this.path = _data["path"];
            this.queryString = _data["queryString"];
            this.payload = _data["payload"];
            this.statusCode = _data["statusCode"];
            this.durationMs = _data["durationMs"];
            this.ipAddress = _data["ipAddress"];
            this.userAgent = _data["userAgent"];
            this.groupId = _data["groupId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApiLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userIdentifier"] = this.userIdentifier;
        data["httpMethod"] = this.httpMethod;
        data["path"] = this.path;
        data["queryString"] = this.queryString;
        data["payload"] = this.payload;
        data["statusCode"] = this.statusCode;
        data["durationMs"] = this.durationMs;
        data["ipAddress"] = this.ipAddress;
        data["userAgent"] = this.userAgent;
        data["groupId"] = this.groupId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApiLogDto {
    id: string;
    userId?: string | undefined;
    userIdentifier?: string | undefined;
    httpMethod: string | undefined;
    path: string | undefined;
    queryString?: string | undefined;
    payload?: string | undefined;
    statusCode: number;
    durationMs: number;
    ipAddress?: string | undefined;
    userAgent?: string | undefined;
    groupId?: string | undefined;
    timestamp: Date;
}

export class ApiLogDtoODataDto implements IApiLogDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: ApiLogDto[] | undefined;

    constructor(data?: IApiLogDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ApiLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApiLogDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiLogDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApiLogDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: ApiLogDto[] | undefined;
}

export class AppUserDetailsDto implements IAppUserDetailsDto {
    user!: UserDto;
    groups!: AppUserGroupDto[] | undefined;

    constructor(data?: IAppUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : new UserDto();
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(AppUserGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppUserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppUserDetailsDto {
    user: UserDto;
    groups: AppUserGroupDto[] | undefined;
}

export class AppUserGroupDto implements IAppUserGroupDto {
    id!: string;
    name!: string | undefined;
    type!: GroupType;
    roleId!: string;
    vehicles!: VehicleDto[] | undefined;
    batteries!: BatteryDto[] | undefined;
    batterySubscriptions!: BatterySubscriptionDto[] | undefined;
    homeChargerSubscriptions!: HomeChargerSubscriptionDto[] | undefined;

    constructor(data?: IAppUserGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.roleId = _data["roleId"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(VehicleDto.fromJS(item));
            }
            if (Array.isArray(_data["batteries"])) {
                this.batteries = [] as any;
                for (let item of _data["batteries"])
                    this.batteries!.push(BatteryDto.fromJS(item));
            }
            if (Array.isArray(_data["batterySubscriptions"])) {
                this.batterySubscriptions = [] as any;
                for (let item of _data["batterySubscriptions"])
                    this.batterySubscriptions!.push(BatterySubscriptionDto.fromJS(item));
            }
            if (Array.isArray(_data["homeChargerSubscriptions"])) {
                this.homeChargerSubscriptions = [] as any;
                for (let item of _data["homeChargerSubscriptions"])
                    this.homeChargerSubscriptions!.push(HomeChargerSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppUserGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["roleId"] = this.roleId;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.batteries)) {
            data["batteries"] = [];
            for (let item of this.batteries)
                data["batteries"].push(item.toJSON());
        }
        if (Array.isArray(this.batterySubscriptions)) {
            data["batterySubscriptions"] = [];
            for (let item of this.batterySubscriptions)
                data["batterySubscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.homeChargerSubscriptions)) {
            data["homeChargerSubscriptions"] = [];
            for (let item of this.homeChargerSubscriptions)
                data["homeChargerSubscriptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppUserGroupDto {
    id: string;
    name: string | undefined;
    type: GroupType;
    roleId: string;
    vehicles: VehicleDto[] | undefined;
    batteries: BatteryDto[] | undefined;
    batterySubscriptions: BatterySubscriptionDto[] | undefined;
    homeChargerSubscriptions: HomeChargerSubscriptionDto[] | undefined;
}

export class AuthorizedPolicyDto implements IAuthorizedPolicyDto {
    policyName!: string | undefined;
    allowedEndpoints!: AuthorizedPolicyEndpointDto[] | undefined;

    constructor(data?: IAuthorizedPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyName = _data["policyName"];
            if (Array.isArray(_data["allowedEndpoints"])) {
                this.allowedEndpoints = [] as any;
                for (let item of _data["allowedEndpoints"])
                    this.allowedEndpoints!.push(AuthorizedPolicyEndpointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthorizedPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizedPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyName"] = this.policyName;
        if (Array.isArray(this.allowedEndpoints)) {
            data["allowedEndpoints"] = [];
            for (let item of this.allowedEndpoints)
                data["allowedEndpoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuthorizedPolicyDto {
    policyName: string | undefined;
    allowedEndpoints: AuthorizedPolicyEndpointDto[] | undefined;
}

export class AuthorizedPolicyEndpointDto implements IAuthorizedPolicyEndpointDto {
    url!: string | undefined;
    methods!: string[] | undefined;

    constructor(data?: IAuthorizedPolicyEndpointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            if (Array.isArray(_data["methods"])) {
                this.methods = [] as any;
                for (let item of _data["methods"])
                    this.methods!.push(item);
            }
        }
    }

    static fromJS(data: any): AuthorizedPolicyEndpointDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizedPolicyEndpointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        if (Array.isArray(this.methods)) {
            data["methods"] = [];
            for (let item of this.methods)
                data["methods"].push(item);
        }
        return data;
    }
}

export interface IAuthorizedPolicyEndpointDto {
    url: string | undefined;
    methods: string[] | undefined;
}

export class BackofficeUserDto implements IBackofficeUserDto {
    id!: string;
    name!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    role!: string | undefined;
    updateDate!: Date;
    userSettings!: UserSettingsDto;

    constructor(data?: IBackofficeUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userSettings = new UserSettingsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.userSettings = _data["userSettings"] ? UserSettingsDto.fromJS(_data["userSettings"]) : new UserSettingsDto();
        }
    }

    static fromJS(data: any): BackofficeUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackofficeUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["role"] = this.role;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["userSettings"] = this.userSettings ? this.userSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBackofficeUserDto {
    id: string;
    name: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    role: string | undefined;
    updateDate: Date;
    userSettings: UserSettingsDto;
}

export class BackofficeUserDtoODataDto implements IBackofficeUserDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: BackofficeUserDto[] | undefined;

    constructor(data?: IBackofficeUserDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(BackofficeUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BackofficeUserDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackofficeUserDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBackofficeUserDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: BackofficeUserDto[] | undefined;
}

export class BatteryCreateRequest implements IBatteryCreateRequest {
    bcuUid!: string | undefined;
    serialNumber!: string | undefined;
    stateOfCharge?: number | undefined;
    fwVersion?: string | undefined;

    constructor(data?: IBatteryCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bcuUid = _data["bcuUid"];
            this.serialNumber = _data["serialNumber"];
            this.stateOfCharge = _data["stateOfCharge"];
            this.fwVersion = _data["fwVersion"];
        }
    }

    static fromJS(data: any): BatteryCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bcuUid"] = this.bcuUid;
        data["serialNumber"] = this.serialNumber;
        data["stateOfCharge"] = this.stateOfCharge;
        data["fwVersion"] = this.fwVersion;
        return data;
    }
}

export interface IBatteryCreateRequest {
    bcuUid: string | undefined;
    serialNumber: string | undefined;
    stateOfCharge?: number | undefined;
    fwVersion?: string | undefined;
}

export class BatteryDto implements IBatteryDto {
    id!: string;
    bcuUid!: string | undefined;
    serialNumber!: string | undefined;
    stateOfCharge!: number;
    userId!: string | undefined;
    vehicleId!: string | undefined;
    groupId!: string | undefined;
    batteryStationId!: string | undefined;
    fwVersion!: string | undefined;
    updateDate!: Date;

    constructor(data?: IBatteryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bcuUid = _data["bcuUid"];
            this.serialNumber = _data["serialNumber"];
            this.stateOfCharge = _data["stateOfCharge"];
            this.userId = _data["userId"];
            this.vehicleId = _data["vehicleId"];
            this.groupId = _data["groupId"];
            this.batteryStationId = _data["batteryStationId"];
            this.fwVersion = _data["fwVersion"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BatteryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bcuUid"] = this.bcuUid;
        data["serialNumber"] = this.serialNumber;
        data["stateOfCharge"] = this.stateOfCharge;
        data["userId"] = this.userId;
        data["vehicleId"] = this.vehicleId;
        data["groupId"] = this.groupId;
        data["batteryStationId"] = this.batteryStationId;
        data["fwVersion"] = this.fwVersion;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBatteryDto {
    id: string;
    bcuUid: string | undefined;
    serialNumber: string | undefined;
    stateOfCharge: number;
    userId: string | undefined;
    vehicleId: string | undefined;
    groupId: string | undefined;
    batteryStationId: string | undefined;
    fwVersion: string | undefined;
    updateDate: Date;
}

export class BatteryDtoODataDto implements IBatteryDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: BatteryDto[] | undefined;

    constructor(data?: IBatteryDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(BatteryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatteryDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatteryDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: BatteryDto[] | undefined;
}

export class BatteryFirmwareDto implements IBatteryFirmwareDto {
    id!: string;
    version!: string | undefined;
    fileUrl!: string | undefined;
    description?: string | undefined;
    released?: boolean;

    constructor(data?: IBatteryFirmwareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.fileUrl = _data["fileUrl"];
            this.description = _data["description"];
            this.released = _data["released"];
        }
    }

    static fromJS(data: any): BatteryFirmwareDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryFirmwareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["fileUrl"] = this.fileUrl;
        data["description"] = this.description;
        data["released"] = this.released;
        return data;
    }
}

export interface IBatteryFirmwareDto {
    id: string;
    version: string | undefined;
    fileUrl: string | undefined;
    description?: string | undefined;
    released?: boolean;
}

export class BatteryFirmwareDtoODataDto implements IBatteryFirmwareDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: BatteryFirmwareDto[] | undefined;

    constructor(data?: IBatteryFirmwareDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(BatteryFirmwareDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatteryFirmwareDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryFirmwareDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatteryFirmwareDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: BatteryFirmwareDto[] | undefined;
}

export class BatteryFirmwareUpdateRequest implements IBatteryFirmwareUpdateRequest {
    description!: string | undefined;
    released?: boolean | undefined;

    constructor(data?: IBatteryFirmwareUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.released = _data["released"];
        }
    }

    static fromJS(data: any): BatteryFirmwareUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryFirmwareUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["released"] = this.released;
        return data;
    }
}

export interface IBatteryFirmwareUpdateRequest {
    description: string | undefined;
    released?: boolean | undefined;
}

export class BatteryStationCreateRequest implements IBatteryStationCreateRequest {
    serialNumber!: string | undefined;
    deviceTagId!: string | undefined;
    name?: string | undefined;
    chargedBatteries?: number | undefined;
    gpsCoordinates?: GpsCoordinateDto;
    address?: string | undefined;
    timeZoneId?: string | undefined;
    spareBatteries?: number | undefined;

    constructor(data?: IBatteryStationCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.deviceTagId = _data["deviceTagId"];
            this.name = _data["name"];
            this.chargedBatteries = _data["chargedBatteries"];
            this.gpsCoordinates = _data["gpsCoordinates"] ? GpsCoordinateDto.fromJS(_data["gpsCoordinates"]) : <any>undefined;
            this.address = _data["address"];
            this.timeZoneId = _data["timeZoneId"];
            this.spareBatteries = _data["spareBatteries"];
        }
    }

    static fromJS(data: any): BatteryStationCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryStationCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["deviceTagId"] = this.deviceTagId;
        data["name"] = this.name;
        data["chargedBatteries"] = this.chargedBatteries;
        data["gpsCoordinates"] = this.gpsCoordinates ? this.gpsCoordinates.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["timeZoneId"] = this.timeZoneId;
        data["spareBatteries"] = this.spareBatteries;
        return data;
    }
}

export interface IBatteryStationCreateRequest {
    serialNumber: string | undefined;
    deviceTagId: string | undefined;
    name?: string | undefined;
    chargedBatteries?: number | undefined;
    gpsCoordinates?: GpsCoordinateDto;
    address?: string | undefined;
    timeZoneId?: string | undefined;
    spareBatteries?: number | undefined;
}

export class BatteryStationDto implements IBatteryStationDto {
    id!: string;
    serialNumber!: string | undefined;
    deviceTagId!: string | undefined;
    gpsCoordinates!: GpsCoordinateDto;
    updateDate!: Date;
    name!: string | undefined;
    address!: string | undefined;
    timeZoneId!: string | undefined;
    chargedBatteries!: number;
    spareBatteries!: number;

    constructor(data?: IBatteryStationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.gpsCoordinates = new GpsCoordinateDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.deviceTagId = _data["deviceTagId"];
            this.gpsCoordinates = _data["gpsCoordinates"] ? GpsCoordinateDto.fromJS(_data["gpsCoordinates"]) : new GpsCoordinateDto();
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.address = _data["address"];
            this.timeZoneId = _data["timeZoneId"];
            this.chargedBatteries = _data["chargedBatteries"];
            this.spareBatteries = _data["spareBatteries"];
        }
    }

    static fromJS(data: any): BatteryStationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryStationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["deviceTagId"] = this.deviceTagId;
        data["gpsCoordinates"] = this.gpsCoordinates ? this.gpsCoordinates.toJSON() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["address"] = this.address;
        data["timeZoneId"] = this.timeZoneId;
        data["chargedBatteries"] = this.chargedBatteries;
        data["spareBatteries"] = this.spareBatteries;
        return data;
    }
}

export interface IBatteryStationDto {
    id: string;
    serialNumber: string | undefined;
    deviceTagId: string | undefined;
    gpsCoordinates: GpsCoordinateDto;
    updateDate: Date;
    name: string | undefined;
    address: string | undefined;
    timeZoneId: string | undefined;
    chargedBatteries: number;
    spareBatteries: number;
}

export class BatteryStationDtoODataDto implements IBatteryStationDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: BatteryStationDto[] | undefined;

    constructor(data?: IBatteryStationDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(BatteryStationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatteryStationDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryStationDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatteryStationDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: BatteryStationDto[] | undefined;
}

export class BatteryStationUpdateRequest implements IBatteryStationUpdateRequest {
    serialNumber!: string | undefined;
    deviceTagId!: string | undefined;
    name?: string | undefined;
    chargedBatteries?: number | undefined;
    gpsCoordinates?: GpsCoordinateDto;
    address?: string | undefined;
    timeZoneId?: string | undefined;
    spareBatteries?: number | undefined;

    constructor(data?: IBatteryStationUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.deviceTagId = _data["deviceTagId"];
            this.name = _data["name"];
            this.chargedBatteries = _data["chargedBatteries"];
            this.gpsCoordinates = _data["gpsCoordinates"] ? GpsCoordinateDto.fromJS(_data["gpsCoordinates"]) : <any>undefined;
            this.address = _data["address"];
            this.timeZoneId = _data["timeZoneId"];
            this.spareBatteries = _data["spareBatteries"];
        }
    }

    static fromJS(data: any): BatteryStationUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryStationUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["deviceTagId"] = this.deviceTagId;
        data["name"] = this.name;
        data["chargedBatteries"] = this.chargedBatteries;
        data["gpsCoordinates"] = this.gpsCoordinates ? this.gpsCoordinates.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["timeZoneId"] = this.timeZoneId;
        data["spareBatteries"] = this.spareBatteries;
        return data;
    }
}

export interface IBatteryStationUpdateRequest {
    serialNumber: string | undefined;
    deviceTagId: string | undefined;
    name?: string | undefined;
    chargedBatteries?: number | undefined;
    gpsCoordinates?: GpsCoordinateDto;
    address?: string | undefined;
    timeZoneId?: string | undefined;
    spareBatteries?: number | undefined;
}

export class BatterySubscriptionCreateRequest implements IBatterySubscriptionCreateRequest {
    shopSubscriptionId!: string | undefined;
    groupId!: string;
    status!: SubscriptionStatus;
    expirationDate!: Date;

    constructor(data?: IBatterySubscriptionCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shopSubscriptionId = _data["shopSubscriptionId"];
            this.groupId = _data["groupId"];
            this.status = _data["status"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BatterySubscriptionCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatterySubscriptionCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shopSubscriptionId"] = this.shopSubscriptionId;
        data["groupId"] = this.groupId;
        data["status"] = this.status;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBatterySubscriptionCreateRequest {
    shopSubscriptionId: string | undefined;
    groupId: string;
    status: SubscriptionStatus;
    expirationDate: Date;
}

export class BatterySubscriptionDto implements IBatterySubscriptionDto {
    shopSubscriptionId!: string | undefined;
    groupId!: string;
    status!: SubscriptionStatus;
    expirationDate!: Date;

    constructor(data?: IBatterySubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shopSubscriptionId = _data["shopSubscriptionId"];
            this.groupId = _data["groupId"];
            this.status = _data["status"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BatterySubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatterySubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shopSubscriptionId"] = this.shopSubscriptionId;
        data["groupId"] = this.groupId;
        data["status"] = this.status;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBatterySubscriptionDto {
    shopSubscriptionId: string | undefined;
    groupId: string;
    status: SubscriptionStatus;
    expirationDate: Date;
}

export class BatterySubscriptionSummaryDto implements IBatterySubscriptionSummaryDto {
    shopSubscriptionId!: string | undefined;
    groupId!: string;
    groupCreateUserId?: string;
    groupCreatedUserEmail?: string | undefined;
    status!: SubscriptionStatus;
    expirationDate!: Date;

    constructor(data?: IBatterySubscriptionSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shopSubscriptionId = _data["shopSubscriptionId"];
            this.groupId = _data["groupId"];
            this.groupCreateUserId = _data["groupCreateUserId"];
            this.groupCreatedUserEmail = _data["groupCreatedUserEmail"];
            this.status = _data["status"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BatterySubscriptionSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatterySubscriptionSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shopSubscriptionId"] = this.shopSubscriptionId;
        data["groupId"] = this.groupId;
        data["groupCreateUserId"] = this.groupCreateUserId;
        data["groupCreatedUserEmail"] = this.groupCreatedUserEmail;
        data["status"] = this.status;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBatterySubscriptionSummaryDto {
    shopSubscriptionId: string | undefined;
    groupId: string;
    groupCreateUserId?: string;
    groupCreatedUserEmail?: string | undefined;
    status: SubscriptionStatus;
    expirationDate: Date;
}

export class BatterySubscriptionUpdateRequest implements IBatterySubscriptionUpdateRequest {
    status!: SubscriptionStatus;
    expirationDate!: Date;

    constructor(data?: IBatterySubscriptionUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BatterySubscriptionUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatterySubscriptionUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBatterySubscriptionUpdateRequest {
    status: SubscriptionStatus;
    expirationDate: Date;
}

export class BatteryUpdateRequest implements IBatteryUpdateRequest {
    bcuUid!: string | undefined;
    serialNumber!: string | undefined;
    stateOfCharge!: number;
    groupId!: string | undefined;
    batteryStationId!: string | undefined;
    fwVersion!: string | undefined;

    constructor(data?: IBatteryUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bcuUid = _data["bcuUid"];
            this.serialNumber = _data["serialNumber"];
            this.stateOfCharge = _data["stateOfCharge"];
            this.groupId = _data["groupId"];
            this.batteryStationId = _data["batteryStationId"];
            this.fwVersion = _data["fwVersion"];
        }
    }

    static fromJS(data: any): BatteryUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatteryUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bcuUid"] = this.bcuUid;
        data["serialNumber"] = this.serialNumber;
        data["stateOfCharge"] = this.stateOfCharge;
        data["groupId"] = this.groupId;
        data["batteryStationId"] = this.batteryStationId;
        data["fwVersion"] = this.fwVersion;
        return data;
    }
}

export interface IBatteryUpdateRequest {
    bcuUid: string | undefined;
    serialNumber: string | undefined;
    stateOfCharge: number;
    groupId: string | undefined;
    batteryStationId: string | undefined;
    fwVersion: string | undefined;
}

export class GpsCoordinateDto implements IGpsCoordinateDto {
    latitude!: number;
    longitude!: number;

    constructor(data?: IGpsCoordinateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): GpsCoordinateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GpsCoordinateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IGpsCoordinateDto {
    latitude: number;
    longitude: number;
}

export class GroupInfoDto implements IGroupInfoDto {
    id!: string;
    name!: string | undefined;
    type!: GroupType;
    numberOfUsers!: number;
    numberOfVehicles!: number;
    updateDate?: Date;
    imageInfo!: ImageInfoDto;

    constructor(data?: IGroupInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.imageInfo = new ImageInfoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.numberOfUsers = _data["numberOfUsers"];
            this.numberOfVehicles = _data["numberOfVehicles"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.imageInfo = _data["imageInfo"] ? ImageInfoDto.fromJS(_data["imageInfo"]) : new ImageInfoDto();
        }
    }

    static fromJS(data: any): GroupInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["numberOfUsers"] = this.numberOfUsers;
        data["numberOfVehicles"] = this.numberOfVehicles;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["imageInfo"] = this.imageInfo ? this.imageInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGroupInfoDto {
    id: string;
    name: string | undefined;
    type: GroupType;
    numberOfUsers: number;
    numberOfVehicles: number;
    updateDate?: Date;
    imageInfo: ImageInfoDto;
}

export class GroupInfoDtoODataDto implements IGroupInfoDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: GroupInfoDto[] | undefined;

    constructor(data?: IGroupInfoDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(GroupInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupInfoDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupInfoDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupInfoDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: GroupInfoDto[] | undefined;
}

export enum GroupType {
    PERSONAL = "PERSONAL",
    COMPANY = "COMPANY",
}

export class HomeChargerCreateRequest implements IHomeChargerCreateRequest {
    serialNumber!: string | undefined;

    constructor(data?: IHomeChargerCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
        }
    }

    static fromJS(data: any): HomeChargerCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HomeChargerCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        return data;
    }
}

export interface IHomeChargerCreateRequest {
    serialNumber: string | undefined;
}

export class HomeChargerDto implements IHomeChargerDto {
    id!: string;
    serialNumber!: string | undefined;
    createDate!: Date;
    updateDate!: Date;

    constructor(data?: IHomeChargerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HomeChargerDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeChargerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHomeChargerDto {
    id: string;
    serialNumber: string | undefined;
    createDate: Date;
    updateDate: Date;
}

export class HomeChargerDtoODataDto implements IHomeChargerDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: HomeChargerDto[] | undefined;

    constructor(data?: IHomeChargerDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(HomeChargerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HomeChargerDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeChargerDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHomeChargerDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: HomeChargerDto[] | undefined;
}

export class HomeChargerSubscriptionCreateRequest implements IHomeChargerSubscriptionCreateRequest {
    shopSubscriptionId!: string | undefined;
    groupId!: string;
    status!: SubscriptionStatus;
    expirationDate!: Date;

    constructor(data?: IHomeChargerSubscriptionCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shopSubscriptionId = _data["shopSubscriptionId"];
            this.groupId = _data["groupId"];
            this.status = _data["status"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HomeChargerSubscriptionCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HomeChargerSubscriptionCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shopSubscriptionId"] = this.shopSubscriptionId;
        data["groupId"] = this.groupId;
        data["status"] = this.status;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHomeChargerSubscriptionCreateRequest {
    shopSubscriptionId: string | undefined;
    groupId: string;
    status: SubscriptionStatus;
    expirationDate: Date;
}

export class HomeChargerSubscriptionDto implements IHomeChargerSubscriptionDto {
    shopSubscriptionId!: string | undefined;
    groupId!: string;
    status!: SubscriptionStatus;
    expirationDate!: Date;

    constructor(data?: IHomeChargerSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shopSubscriptionId = _data["shopSubscriptionId"];
            this.groupId = _data["groupId"];
            this.status = _data["status"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HomeChargerSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeChargerSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shopSubscriptionId"] = this.shopSubscriptionId;
        data["groupId"] = this.groupId;
        data["status"] = this.status;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHomeChargerSubscriptionDto {
    shopSubscriptionId: string | undefined;
    groupId: string;
    status: SubscriptionStatus;
    expirationDate: Date;
}

export class HomeChargerSubscriptionSummaryDto implements IHomeChargerSubscriptionSummaryDto {
    shopSubscriptionId!: string | undefined;
    groupId!: string;
    groupCreateUserId?: string;
    groupCreatedUserEmail?: string | undefined;
    status!: SubscriptionStatus;
    expirationDate!: Date;

    constructor(data?: IHomeChargerSubscriptionSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shopSubscriptionId = _data["shopSubscriptionId"];
            this.groupId = _data["groupId"];
            this.groupCreateUserId = _data["groupCreateUserId"];
            this.groupCreatedUserEmail = _data["groupCreatedUserEmail"];
            this.status = _data["status"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HomeChargerSubscriptionSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeChargerSubscriptionSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shopSubscriptionId"] = this.shopSubscriptionId;
        data["groupId"] = this.groupId;
        data["groupCreateUserId"] = this.groupCreateUserId;
        data["groupCreatedUserEmail"] = this.groupCreatedUserEmail;
        data["status"] = this.status;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHomeChargerSubscriptionSummaryDto {
    shopSubscriptionId: string | undefined;
    groupId: string;
    groupCreateUserId?: string;
    groupCreatedUserEmail?: string | undefined;
    status: SubscriptionStatus;
    expirationDate: Date;
}

export class HomeChargerSubscriptionUpdateRequest implements IHomeChargerSubscriptionUpdateRequest {
    status!: SubscriptionStatus;
    expirationDate!: Date;

    constructor(data?: IHomeChargerSubscriptionUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HomeChargerSubscriptionUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HomeChargerSubscriptionUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHomeChargerSubscriptionUpdateRequest {
    status: SubscriptionStatus;
    expirationDate: Date;
}

export class HomeChargerUpdateRequest implements IHomeChargerUpdateRequest {
    serialNumber!: string | undefined;

    constructor(data?: IHomeChargerUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
        }
    }

    static fromJS(data: any): HomeChargerUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HomeChargerUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        return data;
    }
}

export interface IHomeChargerUpdateRequest {
    serialNumber: string | undefined;
}

export class ImageInfoDto implements IImageInfoDto {
    url!: string | undefined;
    updateDate!: Date | undefined;

    constructor(data?: IImageInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ImageInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IImageInfoDto {
    url: string | undefined;
    updateDate: Date | undefined;
}

export class InviteUserRequest implements IInviteUserRequest {
    email!: string | undefined;
    roleId!: string;

    constructor(data?: IInviteUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): InviteUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InviteUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IInviteUserRequest {
    email: string | undefined;
    roleId: string;
}

export class NotificationDto implements INotificationDto {
    id!: string;
    sendDate!: Date;
    title!: string | undefined;
    body!: string | undefined;
    emailRecipients!: string[] | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sendDate = _data["sendDate"] ? new Date(_data["sendDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.body = _data["body"];
            if (Array.isArray(_data["emailRecipients"])) {
                this.emailRecipients = [] as any;
                for (let item of _data["emailRecipients"])
                    this.emailRecipients!.push(item);
            }
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["body"] = this.body;
        if (Array.isArray(this.emailRecipients)) {
            data["emailRecipients"] = [];
            for (let item of this.emailRecipients)
                data["emailRecipients"].push(item);
        }
        return data;
    }
}

export interface INotificationDto {
    id: string;
    sendDate: Date;
    title: string | undefined;
    body: string | undefined;
    emailRecipients: string[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    userId!: string;
    refreshToken!: string | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenRequest {
    userId: string;
    refreshToken: string | undefined;
}

export class RoleDto implements IRoleDto {
    id!: string;
    name!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRoleDto {
    id: string;
    name: string | undefined;
    displayName: string | undefined;
}

export class RoleDtoODataDto implements IRoleDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: RoleDto[] | undefined;

    constructor(data?: IRoleDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: RoleDto[] | undefined;
}

export enum SCoreUnitOfMeasureType {
    METRIC = "METRIC",
    IMPERIAL = "IMPERIAL",
}

export class SendNotificationRequest implements ISendNotificationRequest {
    title!: string | undefined;
    body!: string | undefined;
    emailRecipients!: string[] | undefined;

    constructor(data?: ISendNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.body = _data["body"];
            if (Array.isArray(_data["emailRecipients"])) {
                this.emailRecipients = [] as any;
                for (let item of _data["emailRecipients"])
                    this.emailRecipients!.push(item);
            }
        }
    }

    static fromJS(data: any): SendNotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["body"] = this.body;
        if (Array.isArray(this.emailRecipients)) {
            data["emailRecipients"] = [];
            for (let item of this.emailRecipients)
                data["emailRecipients"].push(item);
        }
        return data;
    }
}

export interface ISendNotificationRequest {
    title: string | undefined;
    body: string | undefined;
    emailRecipients: string[] | undefined;
}

export class SetTesterRequest implements ISetTesterRequest {
    isTester!: boolean;

    constructor(data?: ISetTesterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTester = _data["isTester"];
        }
    }

    static fromJS(data: any): SetTesterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetTesterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTester"] = this.isTester;
        return data;
    }
}

export interface ISetTesterRequest {
    isTester: boolean;
}

export enum SubscriptionStatus {
    Pending = "Pending",
    Active = "Active",
    NotActive = "NotActive",
}

export class SwapDto implements ISwapDto {
    id!: string;
    batteryStationId!: string;
    batteryStationSerialNumber!: string | undefined;
    userId!: string;
    userEmail!: string | undefined;
    groupId!: string;
    status!: SwapStatus;
    statusTimeStamp!: Date;
    swapProcedureState!: string | undefined;
    returnedBatteryId!: string | undefined;
    providedBatteryId!: string | undefined;

    constructor(data?: ISwapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.batteryStationId = _data["batteryStationId"];
            this.batteryStationSerialNumber = _data["batteryStationSerialNumber"];
            this.userId = _data["userId"];
            this.userEmail = _data["userEmail"];
            this.groupId = _data["groupId"];
            this.status = _data["status"];
            this.statusTimeStamp = _data["statusTimeStamp"] ? new Date(_data["statusTimeStamp"].toString()) : <any>undefined;
            this.swapProcedureState = _data["swapProcedureState"];
            this.returnedBatteryId = _data["returnedBatteryId"];
            this.providedBatteryId = _data["providedBatteryId"];
        }
    }

    static fromJS(data: any): SwapDto {
        data = typeof data === 'object' ? data : {};
        let result = new SwapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["batteryStationId"] = this.batteryStationId;
        data["batteryStationSerialNumber"] = this.batteryStationSerialNumber;
        data["userId"] = this.userId;
        data["userEmail"] = this.userEmail;
        data["groupId"] = this.groupId;
        data["status"] = this.status;
        data["statusTimeStamp"] = this.statusTimeStamp ? this.statusTimeStamp.toISOString() : <any>undefined;
        data["swapProcedureState"] = this.swapProcedureState;
        data["returnedBatteryId"] = this.returnedBatteryId;
        data["providedBatteryId"] = this.providedBatteryId;
        return data;
    }
}

export interface ISwapDto {
    id: string;
    batteryStationId: string;
    batteryStationSerialNumber: string | undefined;
    userId: string;
    userEmail: string | undefined;
    groupId: string;
    status: SwapStatus;
    statusTimeStamp: Date;
    swapProcedureState: string | undefined;
    returnedBatteryId: string | undefined;
    providedBatteryId: string | undefined;
}

export class SwapDtoODataDto implements ISwapDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: SwapDto[] | undefined;

    constructor(data?: ISwapDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(SwapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SwapDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SwapDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISwapDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: SwapDto[] | undefined;
}

export enum SwapStatus {
    ONGOING = "ONGOING",
    COMPLETED = "COMPLETED",
    COMPLETED_WITH_PROBLEM = "COMPLETED_WITH_PROBLEM",
    ABORTED_BY_APP = "ABORTED_BY_APP",
    FAILED = "FAILED",
}

export class TokenDto implements ITokenDto {
    userId?: string;
    email?: string | undefined;
    token?: string | undefined;
    expiration?: Date;
    refreshToken?: string | undefined;

    constructor(data?: ITokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): TokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["token"] = this.token;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ITokenDto {
    userId?: string;
    email?: string | undefined;
    token?: string | undefined;
    expiration?: Date;
    refreshToken?: string | undefined;
}

export class UpdateSwapRequest implements IUpdateSwapRequest {
    status!: SwapStatus;

    constructor(data?: IUpdateSwapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateSwapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSwapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateSwapRequest {
    status: SwapStatus;
}

export class UserDto implements IUserDto {
    id!: string;
    name!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    isActive!: boolean;
    isTester!: boolean;
    isDeleted!: boolean;
    isAnonymized!: boolean;
    phoneNumber!: string | undefined;
    postalCode!: string | undefined;
    country!: string | undefined;
    city!: string | undefined;
    address!: string | undefined;
    updateDate!: Date;
    userSettings!: UserSettingsDto;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userSettings = new UserSettingsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.isTester = _data["isTester"];
            this.isDeleted = _data["isDeleted"];
            this.isAnonymized = _data["isAnonymized"];
            this.phoneNumber = _data["phoneNumber"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.userSettings = _data["userSettings"] ? UserSettingsDto.fromJS(_data["userSettings"]) : new UserSettingsDto();
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["isTester"] = this.isTester;
        data["isDeleted"] = this.isDeleted;
        data["isAnonymized"] = this.isAnonymized;
        data["phoneNumber"] = this.phoneNumber;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["city"] = this.city;
        data["address"] = this.address;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["userSettings"] = this.userSettings ? this.userSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserDto {
    id: string;
    name: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    isActive: boolean;
    isTester: boolean;
    isDeleted: boolean;
    isAnonymized: boolean;
    phoneNumber: string | undefined;
    postalCode: string | undefined;
    country: string | undefined;
    city: string | undefined;
    address: string | undefined;
    updateDate: Date;
    userSettings: UserSettingsDto;
}

export class UserDtoODataDto implements IUserDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: UserDto[] | undefined;

    constructor(data?: IUserDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: UserDto[] | undefined;
}

export class UserRoleUpdateRequest implements IUserRoleUpdateRequest {
    roleId!: string;

    constructor(data?: IUserRoleUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserRoleUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IUserRoleUpdateRequest {
    roleId: string;
}

export class UserSettingsDto implements IUserSettingsDto {
    language!: string | undefined;
    unitOfMeasure!: SCoreUnitOfMeasureType;
    privacyConsent!: boolean;

    constructor(data?: IUserSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.privacyConsent = _data["privacyConsent"];
        }
    }

    static fromJS(data: any): UserSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["privacyConsent"] = this.privacyConsent;
        return data;
    }
}

export interface IUserSettingsDto {
    language: string | undefined;
    unitOfMeasure: SCoreUnitOfMeasureType;
    privacyConsent: boolean;
}

export class VehicleCreateRequest implements IVehicleCreateRequest {
    vcuUid!: string | undefined;
    serialNumber!: string | undefined;
    modelId!: string;
    hasTrackerIoT!: boolean;

    constructor(data?: IVehicleCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vcuUid = _data["vcuUid"];
            this.serialNumber = _data["serialNumber"];
            this.modelId = _data["modelId"];
            this.hasTrackerIoT = _data["hasTrackerIoT"];
        }
    }

    static fromJS(data: any): VehicleCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vcuUid"] = this.vcuUid;
        data["serialNumber"] = this.serialNumber;
        data["modelId"] = this.modelId;
        data["hasTrackerIoT"] = this.hasTrackerIoT;
        return data;
    }
}

export interface IVehicleCreateRequest {
    vcuUid: string | undefined;
    serialNumber: string | undefined;
    modelId: string;
    hasTrackerIoT: boolean;
}

export class VehicleDto implements IVehicleDto {
    id!: string;
    name!: string | undefined;
    vcuUid!: string | undefined;
    serialNumber!: string | undefined;
    model!: VehicleModelDto;
    groupId!: string | undefined;
    hasTrackerIoT!: boolean;
    updateDate!: Date;
    lastPosition?: GpsCoordinateDto;
    lastPositionEventTime?: Date | undefined;

    constructor(data?: IVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = new VehicleModelDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.vcuUid = _data["vcuUid"];
            this.serialNumber = _data["serialNumber"];
            this.model = _data["model"] ? VehicleModelDto.fromJS(_data["model"]) : new VehicleModelDto();
            this.groupId = _data["groupId"];
            this.hasTrackerIoT = _data["hasTrackerIoT"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
            this.lastPosition = _data["lastPosition"] ? GpsCoordinateDto.fromJS(_data["lastPosition"]) : <any>undefined;
            this.lastPositionEventTime = _data["lastPositionEventTime"] ? new Date(_data["lastPositionEventTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["vcuUid"] = this.vcuUid;
        data["serialNumber"] = this.serialNumber;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        data["groupId"] = this.groupId;
        data["hasTrackerIoT"] = this.hasTrackerIoT;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        data["lastPosition"] = this.lastPosition ? this.lastPosition.toJSON() : <any>undefined;
        data["lastPositionEventTime"] = this.lastPositionEventTime ? this.lastPositionEventTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVehicleDto {
    id: string;
    name: string | undefined;
    vcuUid: string | undefined;
    serialNumber: string | undefined;
    model: VehicleModelDto;
    groupId: string | undefined;
    hasTrackerIoT: boolean;
    updateDate: Date;
    lastPosition?: GpsCoordinateDto;
    lastPositionEventTime?: Date | undefined;
}

export class VehicleDtoODataDto implements IVehicleDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: VehicleDto[] | undefined;

    constructor(data?: IVehicleDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VehicleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVehicleDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: VehicleDto[] | undefined;
}

export class VehicleFirmwareDto implements IVehicleFirmwareDto {
    id!: string;
    vehicleModelId!: string;
    version!: string | undefined;
    fileUrl!: string | undefined;
    description?: string | undefined;
    released?: boolean;

    constructor(data?: IVehicleFirmwareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleModelId = _data["vehicleModelId"];
            this.version = _data["version"];
            this.fileUrl = _data["fileUrl"];
            this.description = _data["description"];
            this.released = _data["released"];
        }
    }

    static fromJS(data: any): VehicleFirmwareDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleFirmwareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleModelId"] = this.vehicleModelId;
        data["version"] = this.version;
        data["fileUrl"] = this.fileUrl;
        data["description"] = this.description;
        data["released"] = this.released;
        return data;
    }
}

export interface IVehicleFirmwareDto {
    id: string;
    vehicleModelId: string;
    version: string | undefined;
    fileUrl: string | undefined;
    description?: string | undefined;
    released?: boolean;
}

export class VehicleFirmwareDtoODataDto implements IVehicleFirmwareDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: VehicleFirmwareDto[] | undefined;

    constructor(data?: IVehicleFirmwareDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VehicleFirmwareDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleFirmwareDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleFirmwareDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVehicleFirmwareDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: VehicleFirmwareDto[] | undefined;
}

export class VehicleFirmwareUpdateRequest implements IVehicleFirmwareUpdateRequest {
    description!: string | undefined;
    released?: boolean | undefined;

    constructor(data?: IVehicleFirmwareUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.released = _data["released"];
        }
    }

    static fromJS(data: any): VehicleFirmwareUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleFirmwareUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["released"] = this.released;
        return data;
    }
}

export interface IVehicleFirmwareUpdateRequest {
    description: string | undefined;
    released?: boolean | undefined;
}

export class VehicleModelDto implements IVehicleModelDto {
    id!: string;
    code!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;
    batteriesNumber!: number;
    updateDate!: Date;

    constructor(data?: IVehicleModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.batteriesNumber = _data["batteriesNumber"];
            this.updateDate = _data["updateDate"] ? new Date(_data["updateDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["type"] = this.type;
        data["batteriesNumber"] = this.batteriesNumber;
        data["updateDate"] = this.updateDate ? this.updateDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVehicleModelDto {
    id: string;
    code: string | undefined;
    name: string | undefined;
    type: string | undefined;
    batteriesNumber: number;
    updateDate: Date;
}

export class VehicleModelDtoODataDto implements IVehicleModelDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: VehicleModelDto[] | undefined;

    constructor(data?: IVehicleModelDtoODataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odataContext = _data["@odata.context"];
            this.odataCount = _data["@odata.count"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(VehicleModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleModelDtoODataDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelDtoODataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@odata.context"] = this.odataContext;
        data["@odata.count"] = this.odataCount;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVehicleModelDtoODataDto {
    odataContext?: string | undefined;
    odataCount?: number | undefined;
    value?: VehicleModelDto[] | undefined;
}

export class VehicleUpdateRequest implements IVehicleUpdateRequest {
    name!: string | undefined;
    vcuUid!: string | undefined;
    serialNumber!: string | undefined;
    modelId!: string | undefined;
    hasTrackerIoT!: boolean | undefined;
    groupId!: string | undefined;

    constructor(data?: IVehicleUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.vcuUid = _data["vcuUid"];
            this.serialNumber = _data["serialNumber"];
            this.modelId = _data["modelId"];
            this.hasTrackerIoT = _data["hasTrackerIoT"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): VehicleUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["vcuUid"] = this.vcuUid;
        data["serialNumber"] = this.serialNumber;
        data["modelId"] = this.modelId;
        data["hasTrackerIoT"] = this.hasTrackerIoT;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface IVehicleUpdateRequest {
    name: string | undefined;
    vcuUid: string | undefined;
    serialNumber: string | undefined;
    modelId: string | undefined;
    hasTrackerIoT: boolean | undefined;
    groupId: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}